import { h, computed } from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faAddressCard,
  faBuilding,
  faCaretDown,
  faCaretRight,
  faChartBar,
  faCheck,
  faCircle,
  faClipboardList,
  faClock,
  faCog,
  faCopy,
  faDrawPolygon,
  faEdit,
  faEnvelope,
  faEnvelopeOpenText,
  faEye,
  faFileExcel,
  faFileImport,
  faFileInvoice,
  faFileLines,
  faGlobe,
  faGlobeAmericas,
  faGraduationCap,
  faHandshake,
  faKey,
  faLanguage,
  faLifeRing,
  faList,
  faMoneyBill,
  faPen,
  faPlus,
  faPrint,
  faQuestion,
  faRocket,
  faSearch,
  faTag,
  faTasks,
  faTrash,
  faTrashCan,
  faUser,
  faUserLock,
  faUsers,
  faWaveSquare,
  faWrench,
} from '@fortawesome/free-solid-svg-icons';

const iconMap = {
  building: faBuilding,
  'address-card': faAddressCard,
  'caret-down': faCaretDown,
  'caret-right': faCaretRight,
  'chart-bar': faChartBar,
  check: faCheck,
  circle: faCircle,
  'clipboard-list': faClipboardList,
  clock: faClock,
  cog: faCog,
  copy: faCopy,
  'draw-polygon': faDrawPolygon,
  edit: faEdit,
  envelope: faEnvelope,
  'envelope-open-text': faEnvelopeOpenText,
  eye: faEye,
  'file-alt': faFileLines,
  'file-excel': faFileExcel,
  'file-import': faFileImport,
  'file-invoice': faFileInvoice,
  globe: faGlobe,
  'globe-americas': faGlobeAmericas,
  'graduation-cap': faGraduationCap,
  handshake: faHandshake,
  key: faKey,
  language: faLanguage,
  'life-ring': faLifeRing,
  list: faList,
  'money-bill': faMoneyBill,
  pen: faPen,
  plus: faPlus,
  print: faPrint,
  question: faQuestion,
  rocket: faRocket,
  search: faSearch,
  tag: faTag,
  tasks: faTasks,
  trash: faTrash,
  'trash-alt': faTrashCan,
  user: faUser,
  'user-lock': faUserLock,
  users: faUsers,
  'wave-square': faWaveSquare,
  wrench: faWrench,
};

library.add(...Object.values(iconMap));

const FaIcon = {
  name: 'FaIcon',
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  setup(props, { attrs }) {
    const resolvedIcon = computed(() => iconMap[props.name] || props.name);
    return () => h(FontAwesomeIcon, { icon: resolvedIcon.value, ...attrs });
  },
};

export function registerIcons(app) {
  app.component('fa-icon', FaIcon);
}
